module.exports = __webpack_public_path__ + "img/stagionalita-ingredienti.53acbe48.svg";